export const BILLING_CYCLE_MONTHLY = 'monthly';
export const BILLING_CYCLE_YEARLY = 'yearly';



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/constants/plans/billingcycle.js